<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">
    <AppHeader />
    <!-- begin::Body -->
    <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
      <LeftMenu />
      <div class="m-grid__item m-grid__item--fluid m-wrapper">
        <div class="m-content">
          <Stats />
          <div class="row">
            <Services />
            <Properties />
          </div>
        </div>
      </div>
    </div>
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from './common/Header.vue';
import AppFooter from './common/Footer.vue';
import LeftMenu from './common/menus/LeftMenu.vue';

import Stats from './stats/Stats.vue';
import Services from './stats/Services.vue';
import Properties from './stats/Properties.vue';

export default {
    name: 'Dashboard',
    components: {
        AppFooter,
        AppHeader,
        LeftMenu,
        Stats,
        Services,
        Properties,
    },
    data() {
        return {};
    },
    computed: {
    },
};
</script>
